import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';

const MySpaceRoutes = [
    {
        label: '学习日历',
        key: 'study-calendar',
        path: 'study-calendar',
        show: true,
        element: lazy(() => import('@/page/MySpace/StudyCalendar'))
    },
    {
        label: '学习档案',
        key: 'archives',
        path: 'archives',
        show: true,
        element: lazy(() => import('@/page/MySpace/StudyArchives/StudyArchives'))
    },
    {
        label: '订单',
        key: 'order',
        path: 'order',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyOrder/MyOrder'))
    },
    {
        label: '订单详情',
        key: 'order',
        path: 'order-detail',
        show: false,
        element: lazy(() => import('@/page/MySpace/MyOrder/OrderDetail'))
    },
    {
        label: '支付页',
        key: 'payment',
        path: 'payment',
        show: false,
        element: lazy(() => import('@/page/MySpace/MyOrder/Payment'))
    },
    {
        label: '支付页结果',
        key: 'payment-result',
        path: 'payment-result',
        show: false,
        element: lazy(() => import('@/page/MySpace/MyOrder/PayResult'))
    },
    {
        label: '我的互动',
        key: 'myCommunty',
        show: true,
        path: 'myCommunty',
        element: lazy(() => import('@/page/myCommunty/index'))
    },
    {
        label: '我的证书',
        key: 'certificate',
        path: 'my-certificate',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyCertificate'))
    },
    {
        label: '我的报名',
        key: 'registration',
        path: 'my-registration',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyRegistration'))
    },
    {
        label: '我的收藏',
        key: 'collect',
        path: 'my-collect',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyCollect'))
    },
    {
        label: '我的消息',
        key: 'message',
        path: 'my-message',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyMessage'))
    },
    {
        label: '我的消息详情',
        key: 'message-detail',
        path: 'my-message/:id',
        show: true,
        element: lazy(() => import('@/page/MySpace/MyMessage/Detail'))
    },
    {
        show: true,
        label: '我的' + getCorrespondLabel('110'),
        key: 'my-questionnaire',
        path: 'my-questionnaire',
        element: lazy(() => import('@/page/MyQuestionnaire'))
    },
    {
        label: '学习地图',
        key: 'learning-maps',
        path: 'learning-maps',
        element: lazy(() => import('@/page/LearningMaps'))
    },
    // {
    //     label: '地图详情',
    //     key: 'learning-maps',
    //     path: 'learning-maps/:id/:levelId/:state',
    //     element: lazy(() => import('@/page/mapDetails'))
    // },
    {
        show: true,
        label: '我的发票',
        key: 'my-receipt',
        path: 'my-receipt',
        element: lazy(() => import('@/page/MyReceipt'))
    },
    {
        show: true,
        label: '发票预览',
        key: 'receipt-preview',
        path: 'receipt-preview',
        element: lazy(() => import('@/page/MyReceipt/PreviewReceipt'))
    },
    {
        show: false,
        label: '申请发票',
        key: 'apply-receipt',
        path: 'apply-receipt',
        element: lazy(() => import('@/page/MyReceipt/ApplyReceipt'))
    },
    {
        show: false,
        label: '发票详情',
        key: 'receipt-detail',
        path: 'receipt-detail',
        element: lazy(() => import('@/page/MyReceipt/ReceiptDetail'))
    },
    {
        show: false,
        label: '申请退款',
        key: 'apply-refund',
        path: 'apply-refund',
        element: lazy(() => import('@/page/Refund/ApplyRefund'))
    },
    {
        show: false,
        label: '退款详情',
        key: 'refund-detail',
        path: 'refund-detail',
        element: lazy(() => import('@/page/Refund/RefundDetail'))
    },
    {
        show: false,
        label: '我的评论',
        key: 'my-comment',
        path: 'my-comment',
        element: lazy(() => import('@/page/MySpace/MyComment'))
    },
    {
        show: true,
        label: '听评课',
        key: 'lesson-assess',
        path: 'lesson-assess',
        element: lazy(() => import('@/page/LessonAssess'))
    },
    {
        show: false,
        label: '听评课画像',
        key: 'lesson-assess',
        path: 'lesson-assess/portrait',
        element: lazy(() => import('@/page/LessonAssess/portrait'))
    },
    {
        label: getCorrespondLabel('112'),
        key: 'trainingPlan',
        path: 'trainingPlan',
        show: true,
        element: lazy(() => import('@/page/TrainingPlan'))
    },
    {
        show: true,
        label: '我的积分',
        key: 'my-integral',
        path: 'my-integral',
        element: lazy(() => import('@/page/MyIntegral'))
    },
    {
        show: false,
        label: '去兑奖',
        key: 'my-integral/verification',
        path: 'my-integral/verification',
        element: lazy(() => import('@/page/MyIntegral/verification'))
    },
    {
        show: true,
        label: 'AI教学分析',
        key: 'ai-course-evaluate',
        path: 'ai-course-evaluate',
        element: lazy(() => import('@/page/AiCourseEvaluation/Space'))
    }
];
export default MySpaceRoutes;
